<script>
import {defineComponent, onBeforeMount, ref} from "vue";
import InputSwitch from 'primevue/inputswitch';
import ButtonFileUpload from "@/components/buttons/ButtonFileUpload.vue";
import ImageCard from "@/components/cards/ImageCard.vue";
import MainCard from "@/components/cards/MainCard.vue";
import {useApiCall} from "@/composables/useApiCall";
import {
  stubApiCall,
  updateImageStubApiCall,
  updateStubApiCall,
  createStubApiCall
} from "@/services/settings";
import Skeleton from "primevue/skeleton";
import Button from "primevue/button";

export default defineComponent({
  components: {
    Button,
    Skeleton,
    MainCard, ImageCard, ButtonFileUpload,
    InputSwitch
  },
  setup() {
    const checked = ref(false)
    const file = ref(null)
    const isNew = ref(false)
    const errors = ref(null)
    const {
      isLoading: isStubLoading,
      data: stubData,
      error: stubError,
      executeApiCall: getStubAction,
    } = useApiCall(stubApiCall, true)

    const {
      isLoading: isUpdateStubLoading,
      // data: updateStubData,
      error: updateStubError,
      executeApiCall: updateStubAction,
    } = useApiCall(updateStubApiCall, true)

    const {
      isLoading: updateImageStubLoading,
      // data: updateStubData,
      error: updateImageStubError,
      executeApiCall: updateImageStubAction,
    } = useApiCall(updateImageStubApiCall, true)

    const {
      isLoading: createStubLoading,
      // data: createStubData,
      error: createStubError,
      executeApiCall: createStubAction,
    } = useApiCall(createStubApiCall, true)

    const selectFiles = (data) => {
      file.value = data.files[0]
    }

    const update = async () => {
      errors.value = null
      try {
        if (file.value || isNew.value) {
          const formData = new FormData();
          formData.append("image", file.value);
          if (isNew.value) {
            formData.append("active", Number(checked.value));
            await createStubAction(formData)
            isNew.value = false
          } else {
            formData.append("active", checked.value);
            await updateImageStubAction(formData)
          }
        } else {
          await updateStubAction({active: checked.value})
        }
      } catch {
        if (updateStubError.value) {
          console.error(updateStubError.value)
          errors.value = updateStubError.value.data
        }
        if (updateImageStubError.value) {
          console.error(updateImageStubError.value)
          errors.value = updateImageStubError.value.data
        }
        if (createStubError.value) {
          console.error(createStubError.value)
          errors.value = createStubError.value.data
        }
      }
    }

    onBeforeMount(async () => {
      try {
        await getStubAction()
        if (stubData.value && stubData.value.data.image) {
          checked.value = stubData.value.data.active
        } else {
          isNew.value = true
        }
      } catch {
        console.error(stubError.value)
      }
    })

    return {
      checked,
      isStubLoading,
      file,
      stubData,
      selectFiles,
      update,
      isUpdateStubLoading,
      updateImageStubLoading,
      createStubLoading,
      errors,
    };
  }
})
</script>

<template>
  <section class="stub">
    <Skeleton v-if="isStubLoading" height="187px"></Skeleton>
    <template v-else>
      <Button
          @click="update"
          :loading="isUpdateStubLoading || updateImageStubLoading || createStubLoading"
          label="Сохранить изменения"
          class="btn-primary btn-fix-height font-light ml-3 stub__save"
      />
      <div class="stub__header">
        <label class="stub__header-label" for="switch1">Активна</label>
        <InputSwitch v-model="checked"/>
      </div>
      <MainCard title="Изображение">
        <span v-if="errors?.image" class="flex mb-2 text-xs color-error">
          {{ errors.image[0] }}
        </span>
        <div class="grid">
          <div v-if="stubData?.data?.image && !file" class="col-12 md:col-2">
            <ImageCard without-delete :src="stubData.data.image?.preview_url" />
          </div>
          <div v-if="file" class="col-12 md:col-2">
            <ImageCard without-delete :src="file.objectURL" />
          </div>
          <div class="col-12">
            <ButtonFileUpload
                @chooseFiles="selectFiles"
                :label="stubData?.data?.image || file ? 'Заменить изображение' : 'Добавить изображение'"
                :clear-files-after-select="true"
                :multiple="false"
            />
          </div>
        </div>
      </MainCard>
    </template>
  </section>
</template>

<style lang="css" scoped>
.stub {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.stub__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  color: #C3987A;
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  background: white;
}
.stub__save {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
}
::v-deep(.p-inputswitch-slider) {
  box-shadow: unset !important;
}
::v-deep(.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider) {
  background-color: #C3987A;
  &:hover {
    background-color: #C3987A !important;
  }
}
::v-deep(.p-inputswitch.p-inputswitch-checked:not(.p-disabled):hover .p-inputswitch-slider) {
  background-color: #C3987A;
  box-shadow: unset;
}
</style>